export default __webpack_public_path__ + "static/Cashflow 101+202-3-85321eb149051ef56a7ab3817a006a25.jpg";